import * as React from 'react';
import defaultRenderEmpty from './renderEmpty';
const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls)
        return customizePrefixCls;
    return suffixCls ? `ysd-${suffixCls}` : 'ysd';
};
export const ConfigContext = React.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: defaultGetPrefixCls,
    renderEmpty: defaultRenderEmpty
});
export const ConfigConsumer = ConfigContext.Consumer;
